module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/cta1_dochimom-0dcbb1897e3280984627bb8b33b58cd2.png";